"use strict";

exports.__esModule = true;
exports.VimanaIcon = void 0;
var _core = require("@blueprintjs/core");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _icons = require("@blueprintjs/icons");
var _AlertsIcon = require("./AlertsIcon");
var _CommentsIcon = require("./CommentsIcon");
var _CompactListIcon = require("./CompactListIcon");
var _DisconnectionIcon = require("./DisconnectionIcon");
var _GridLayoutIcon = require("./GridLayoutIcon");
var _LagIcon = require("./LagIcon");
var _ListDetailsLayoutIcon = require("./ListDetailsLayoutIcon");
var _TicketsIcon = require("./TicketsIcon");
var _class, _VimanaIcon;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var VimanaIcons = {
  DisconnectionIcon: _DisconnectionIcon.DisconnectionIcon,
  LagIcon: _LagIcon.LagIcon,
  AlertsIcon: _AlertsIcon.AlertsIcon,
  TicketsIcon: _TicketsIcon.TicketsIcon,
  CommentsIcon: _CommentsIcon.CommentsIcon,
  GridLayoutIcon: _GridLayoutIcon.GridLayoutIcon,
  ListDetailsLayoutIcon: _ListDetailsLayoutIcon.ListDetailsLayoutIcon,
  CompactListIcon: _CompactListIcon.CompactListIcon
};
var VimanaIcon = exports.VimanaIcon = (0, _styledComponents.withTheme)(_class = (_VimanaIcon = /*#__PURE__*/function (_Component) {
  function VimanaIcon() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(VimanaIcon, _Component);
  var _proto = VimanaIcon.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      iconSize = _this$props.iconSize,
      alt = _this$props.alt,
      icon = _this$props.icon,
      margin = _this$props.margin;
    var ThemeIcon = VimanaIcons[icon];
    if (ThemeIcon) {
      return /*#__PURE__*/_react["default"].createElement(ThemeIcon, {
        width: iconSize,
        height: iconSize,
        alt: alt,
        style: {
          margin: margin
        }
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: icon,
      style: {
        margin: margin
      },
      alt: alt
    }) || null;
  };
  return VimanaIcon;
}(_react.Component), _VimanaIcon.defaultProps = {
  theme: undefined,
  height: 48,
  width: 48,
  margin: "12px"
}, _VimanaIcon)) || _class;